import {Injectable} from '@angular/core';


export interface ElementIdGenerator {
  getId(prefix: string): string;
}

@Injectable({
  providedIn: 'root'
})
export class ElementIdGenerationService {

  constructor() { }

  public buildIdGenerator(): ElementIdGenerator {
    return new CachingIdGenerator(this.generate());
  }

  private generate(): string {
    // Math.random() returns a number between 0 (inclusive) and 1 (exclusive), i.e. 0.<some-number>. When converting
    // to base 36, '0.' is ends up in the final string as the number is less than 1. Dot ('.') is a special CSS character
    // which means a start of a CSS Class name. So if the generated id is used as a CSS selector, '.' character causes
    // issues. Therefore, grab everything after '.' in the string so that only 0-9 and a-z characters are used
    const n = Math.random();
    return n > 0 ? n.toString(36).substring(2) : '0-0';
  }
}

class CachingIdGenerator implements ElementIdGenerator {

  private readonly SEPARATOR = '-';

  constructor(private readonly randomId: string) { }

  getId(prefix: string): string {
    return prefix + this.SEPARATOR + this.randomId;
  }
}
